export enum TagName {
  MainHeading = 'h1',
  SecondaryHeading = 'h2',
  H3 = 'h3',
  Paragraph = 'p',
  Span = 'span',
  Legend = 'legend',
}
